import { apiGet, apiPost } from '../services/apiClient';

const buildQuery = (params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  const str = qs.toString();
  return str ? `?${str}` : '';
};

const BASE = '/api/admin/finance/refunds';

export const listRefunds = (token, params = {}) => apiGet(`${BASE}${buildQuery(params)}`, token);
export const approveRefund = (token, id) => apiPost(`${BASE}/${id}/approve`, {}, token);
export const rejectRefund = (token, id, payload) => apiPost(`${BASE}/${id}/reject`, payload, token);
export const markRefunded = (token, id) => apiPost(`${BASE}/${id}/mock-mark-refunded`, {}, token);
